import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController
  ) { }



  loading;

  alertProblem(message: string) {
    this.alertCtrl.create(
      {
        header: "There was a problem",
        message: message,
        buttons: ["Ok"]
      }
    ).then(a => a.present())
  }

  alert(header: string, message: string) {
    this.alertCtrl.create({
      header: header,
      message: message,
      buttons: ["Ok"]
    }).then(a => a.present())
  }

  showLoading(message?, duration?) {
    this.loadingCtrl.create({
      message: message || null,
      duration: duration || null
    }).then(l => { l.present(); this.loading = l; })
  }

  hideLoading() {
    this.loadingCtrl.dismiss();
    this.loadingCtrl.dismiss(this.loading.id)
  }

  showModal(component, props?, css?, bgDismiss?) {
    return new Promise((resolve) => {
      this.modalCtrl.create({
        component: component,
        componentProps: props,
        cssClass: css,
        swipeToClose: true,
        backdropDismiss: bgDismiss,
      }).then(m => {
        m.present();
        m.onDidDismiss().then((result) => {
          return resolve(result.data)
        })
      })
    })
  }

  hideModal(props?) {
    this.modalCtrl.dismiss(props)
  }
}
